import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FA4_NAME_TO_ICON } from "./fa4NameMap";

/* Drop-in replacement for the retired react-fontawesome@1 (FA4 CDN era),
   aliased over the package name in vite.config.ts + tsconfig.json — same
   pattern as the react-bootstrap shim. Consumers keep <FontAwesome name=...>. */
export { FA4_NAME_TO_ICON };

type FontAwesomeProps = {
  name: string;
} & Omit<React.ComponentProps<typeof FontAwesomeIcon>, "icon">;

export default function FontAwesome({
  name,
  spin,
  className,
  ...rest
}: FontAwesomeProps) {
  const icon = FA4_NAME_TO_ICON[name];
  if (!icon) {
    console.warn(`FontAwesome shim: unmapped FA4 icon name "${name}"`);
    return (
      <span
        className={className}
        {...(rest as React.HTMLAttributes<HTMLSpanElement>)}
      >
        ?
      </span>
    );
  }
  return (
    <FontAwesomeIcon icon={icon} spin={spin} className={className} {...rest} />
  );
}
